import * as Sentry from '@sentry/browser'
import wfeTokenRefresh from '../util/wfeTokenRefresh'
import config from '../config'
import { bindChannelChunking } from '../util/bindChannelChunking'
import { getJwt } from '../util/jwtLocalstorage'
import { ThunkResult } from './types'
import { uploadFailed, uploadSuccess, uploadToS3, setTraceId, uploadStart } from './upload'

export const keysRequest = () => {
  const jwt = getJwt()
  const WTAI_EXPRESS_URL = config.getWtaiExpressUrl()

  return fetch(WTAI_EXPRESS_URL + '/keys', {
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Cache-Control': 'no-store',
    },
  })
}

export interface KeysResponse {
  channelName: string
  traceId: string
  appKey: string
  cluster: string
}

export const getKeys = async (): Promise<KeysResponse | undefined> => {
  try {
    let response = await keysRequest()

    if (response.status !== 200) {
      await wfeTokenRefresh(response)
      response = await keysRequest()
    }

    return response.json()
  } catch (error) {
    console.error('FAILED TO GET KEYS', error)
  }
}

export interface PusherMessage {
  action: 'uploadPaper'
  message?: {
    url?: string
  }
  error?: string | null
}

export const subscribeToChannel = (): ThunkResult<void> => async (dispatch, _, { pusherClient }) => {
  try {
    dispatch(uploadStart())
    const keys = await getKeys()

    if (!keys) {
      throw new Error('could not fetch keys')
    }
    await pusherClient.initialize(keys.appKey, keys.cluster, () => {}, () => {})
    dispatch(
      setTraceId({
        traceId: keys.traceId,
      })
    )
    if (!pusherClient.uploadChannel) {
      await pusherClient.subscribe(keys.channelName)
    }
    if (!pusherClient.uploadChannel) {
      throw new Error('Error in pusher subscription, unable to get uploadChannel')
    }

    dispatch(uploadToS3)

    bindChannelChunking(pusherClient.uploadChannel, 'uploadPaper', (data: PusherMessage) => {
      const { message, error } = data

      if (error) {
        throw new Error(error)
      }
      if (message && message.url) {
        dispatch(uploadSuccess(message.url))
      }
    })
  } catch (error) {
    if (error) {
      Sentry.captureException(error)
      dispatch(uploadFailed())
    }
  }
}
